import api from "./api";

export const login = async (email: string, password: string, subdomain?: string) => {
  // Platform admin login (no subdomain)
  if (!subdomain) {
    const res = await api.post("/api/super-admin/login", {
      email,
      password,
    });
    return res.data;
  }

  // Tenant login (with subdomain)
  const res = await api.post("/api/auth/login", {
    email,
    password,
    subdomain,
  });
  return res.data;
};
